"use client"

import { Check } from "lucide-react"
import {
  creationFlowBlockClass,
  creationFlowOptionRowClass,
  creationFlowOptionRowSelectedClass,
} from "@/lib/creation-flow-form-styles"
import { cn } from "@/lib/utils"

export type InlinePickerItem = {
  id: string
  name: string
  flag?: string
}

type CreationFlowInlinePickerProps = {
  items: InlinePickerItem[]
  selectedId: string | null | undefined
  onSelect: (id: string) => void
  otherLast?: boolean
  showFlag?: boolean
  className?: string
}

export function CreationFlowInlinePicker({
  items,
  selectedId,
  onSelect,
  otherLast = false,
  showFlag = false,
  className,
}: CreationFlowInlinePickerProps) {
  const rest = otherLast ? items.filter((item) => item.name.toLowerCase() !== "other") : items
  const other = otherLast ? items.filter((item) => item.name.toLowerCase() === "other") : []
  const blockClass = creationFlowBlockClass
  const rowClass = (selected: boolean) =>
    cn(
      "flex w-full items-center justify-between rounded-xl px-4 py-3 text-left transition-colors",
      selected ? creationFlowOptionRowSelectedClass : creationFlowOptionRowClass,
    )
  const labelClass = "text-foreground"
  const dividerClass = "bg-sheet-handle"

  const renderRow = (item: InlinePickerItem) => {
    const selected = selectedId === item.id
    return (
      <button
        key={item.id}
        type="button"
        className={rowClass(selected)}
        onClick={() => onSelect(item.id)}
      >
        <span className={cn("flex min-w-0 items-center gap-2 text-sm font-medium", labelClass)}>
          {showFlag && item.flag ? (
            <span className="shrink-0 text-base leading-none">{item.flag}</span>
          ) : null}
          <span className="truncate">{item.name}</span>
        </span>
        {selected ? <Check className={cn("h-4 w-4 shrink-0", labelClass)} /> : null}
      </button>
    )
  }

  return (
    <div className={cn("space-y-1 p-2", blockClass, className)}>
      {rest.map(renderRow)}
      {other.length > 0 ? (
        <>
          <div className={cn("my-1 h-px", dividerClass)} />
          {other.map(renderRow)}
        </>
      ) : null}
    </div>
  )
}
